
export default {
  name: 'BbCarousel',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    displayImages: {
      type: Number,
      default: 0,
    },
    isLooped: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
      default: '100%',
    },
  },
  data() {
    return {
      activeValue: this.value,
    };
  },
  watch: {
    activeValue() {
      this.$emit('input', this.activeValue);
    },
  },
  computed: {
    imagesAmount() {
      return `${this.activeValue + 1} / ${this.displayImages}`;
    },
  },
  methods: {
    cycleCarousel(button) {
      if (!this.isLooped) {
        if (button === 'prev') {
          return this.activeValue === 0;
        }
        return this.activeValue + 1 === this.displayImages;
      }
      return false;
    },
  },
};
